<template>
    <template v-for="item in listDisp" v-bind:key="item.key">
        <template v-if="'HIDDEN' != item.type">
            <div class="d-flex flex-column"
                 style="margin-top: 24px; margin-left: 16px;"
                 v-bind:style="{'margin-bottom': (isBundle & lastKey == item.key) ? '0px' : '24px'}">
                <div class="setting-title-text d-flex flex-row full-grow-margin-right">
                    <label class="scv-check-label-box">
                        <input type="checkbox" v-model="listEnabled[item.key]" v-bind:disabled="readonly">
                        <template v-if="null == item.title || '' == item.title">
                            <span v-bind:class="[(readonly) ? 'readonly-text' : '']">{{item.key}}</span>
                        </template>
                        <template v-else>
                            <span v-bind:class="[(readonly) ? 'readonly-text' : '']">{{item.title}}</span>
                        </template>
                    </label>
                </div>
                <template v-if="null != item.description">
                    <div class="setting-description-text full-grow-margin-right" 
                         style="margin-top: 16px;" 
                         v-bind:class="[(readonly) ? 'readonly-text' : '']">
                        {{item.description}}
                    </div>
                </template>
                <div class="d-flex flex-grow-1 flex-column">
                    <div v-show="listEnabled[item.key]" v-bind:class="[listEnabled[item.key] ? 'd-flex flex-grow-1 flex-column' : '']">
                        <template v-if="'BOOL' == item.type">
                            <label class="scv-check-label-box setting-no-bundle-margin-top setting-check-margin-left">
                                <input type="checkbox" v-model="settings[item.key]" v-bind:disabled="readonly">
                                <span v-bind:class="[(readonly) ? 'readonly-text' : '']">有効にする</span>
                            </label>
                        </template>
                        <template v-else-if="'INTEGER' == item.type">
                            <MaskInput convertType="half-number"
                                       class="input-text-scv setting-no-bundle-margin-top"
                                       v-model:numValue="settings[item.key]"
                                       style="width: 400px;"
                                       v-bind:disabled="readonly" />
                        </template>
                        <template v-else-if="'STRING' == item.type">
                            <MaskInput convertType="text"
                                       class="input-text-scv d-flex flex-grow-1 setting-no-bundle-margin-top"
                                       v-model="settings[item.key]"
                                       placeholder="文字列"
                                       style="width: 400px;"
                                       v-bind:disabled="readonly" />
                        </template>
                        <template v-else-if="'CHOICE' == item.type">
                            <div class="select-icon setting-no-bundle-margin-top" style="width: 400px;">
                                <select class="input-text-scv d-flex flex-grow-1 over-text" style="width: 0px;" v-model="settings[item.key]" v-bind:disabled="readonly">
                                    <option v-for="drItem in item.entries" :value="drItem.value" :key="drItem.value">{{drItem.name}}</option>
                                </select>
                            </div>
                        </template>
                        <template v-else-if="'MULTISELECT' == item.type">
                            <div class="d-flex flex-column setting-no-bundle-margin-top setting-check-margin-left full-grow-margin-right" style="row-gap: 8px;">
                                <template v-for="drItem in item.entries" :key="drItem.value">
                                    <label class="scv-check-label-box">
                                        <input type="checkbox" v-model="settings[item.key]" :value="drItem.value" v-bind:disabled="readonly">
                                        <span v-bind:class="[(readonly) ? 'readonly-text' : '']">{{drItem.name}}</span>
                                    </label>
                                </template>
                            </div>
                        </template>
                        <template v-else-if="'BUNDLE' == item.type">
                            <div style="margin-left: 40px;">
                                <AppMgrManagedConfiguration :ref="item.key" :readonly="readonly" :list="item.nestedProperties" :listSetting="getListSetting(item.key)" @showBundleArrayModal="showBundleArrayModal" :isBundle="true" />
                            </div>
                        </template>
                        <template v-else-if="'BUNDLE_ARRAY' == item.type">
                            <div class="setting-no-bundle-margin-top full-grow-margin-right" >
                                <template v-if="isCreatedListCtrl">
                                    <ListTitleBar :btnCaption_1="'追加'"
                                                  :btnCaption_2="'編集'"
                                                  :btnCaption_3="'削除'"
                                                  :btnActiveType_1="0"
                                                  :btnActiveType_2="1"
                                                  :btnActiveType_3="3"
                                                  :rowCount="settings[item.key].length"
                                                  @onBtnClicked_1="onBtnAdd(item)"
                                                  @onBtnClicked_2="onBtnUpd(item)"
                                                  @onBtnClicked_3="onBtnDel(item)"
                                                  :selectCount="getSelectCount(item.key)"
                                                  v-bind:disabled="readonly">
                                    </ListTitleBar>
                                </template>
                                <ListCtrl :ref="item.key + '-list'"
                                          :columns="createColumns(item)"
                                          :selectType="2"
                                          :getCellTextFunc="getCellText(item)"
                                          style="min-height: 240px; max-height: 240px;">
                                </ListCtrl>
                            </div>
                        </template>
                        <template v-else>
                            {{item.type}}
                        </template>
                    </div>
                </div>
            </div>
            <template v-if="lastKey != item.key">
                <div class="scv-separator-bg"></div>
            </template>
        </template>
    </template>
</template>

<script lang="ts">
    import { Options, Vue } from 'vue-class-component';
    import { cloneDeep } from 'lodash';
    import MaskInput from '@/components/Input/MaskInput.vue';
    import { ApplicationPolicyConverter } from '@/models/Mobile/AndroidAppDist/ApplicationPolicyConverter';
    import { ListCtrl } from 'lib-vue-v2/components';
    import ListTitleBar from '@/components/ListTitleBar.vue';
    import * as schema from '@/models/Mobile/Android/AndroidManagementV1Schema'
    import { SearchColumnData, SearchColumnType } from '@/models/SearchColumnData';

    @Options({
        props: {
            readonly: { type: Boolean, default: false },  // 読み取り専用

            /* list と listSettingは長さは一致しなくてもいい */
            list: { type: Array, required: true },  // 管理設定情報一覧（Array<schema.AMAPI_ManagedProperty>）
            listSetting: { type: Object, required: true },  // 設定が有効なデータ（{ [key: string]: any }）

            isBundle: { type: Boolean, default: false },    // BUNDLEコンポーネントどうか
        },
        components: {
            MaskInput,
            ListCtrl,
            ListTitleBar,
        },
        emits: [
            /*
             * Bundle_Arrayの追加画面の表示要求
             * @param[in] 表示内容：Array<schema.AMAPI_ManagedProperty>
             * @param[in] 設定内容：{ [key: string]: any }
             * @param[in] Bundle_Arrayのキー名：string
             * @param[in] true(追加) false(編集)：boolean
             */
            'showBundleArrayModal'
        ],
    })

    export default class AppMgrManagedConfiguration extends Vue {
        // props
        private readonly!: boolean;         // 読み取り専用か
        private list!: Array<schema.AMAPI_ManagedProperty>;        // 管理設定情報一覧
        private listSetting!: { [key: string]: any };       // 設定が有効なデータ

        // メンバ変数
        private settings: { [key: string]: any } = {};  // 表示中の設定（listとlistSettingをマージした結果）
        private listDisp: Array<schema.AMAPI_ManagedProperty> = new Array<schema.AMAPI_ManagedProperty>();        // 表示中の管理設定情報一覧
        private listEnabled: { [key: string]: boolean } = {};   // 有効/無効
        private lastKey = "";   // 最後のキーはセパレーターを出さない

        // ポリシー⇔UIデータ
        private converter = new ApplicationPolicyConverter();

        // BundelArrayModalとの受け渡し用
        private selectedBunldeArrayKey = "";    // 現在表示中のBundle_Array追加画面のキー

        // 定数
        private readonly BUNDLE_ARRAY_TYPE_BUNDLE_BASE_COLUMNID = 1000;  // BundleArray内のBundle型のベースとなるカラムID

        // リストを動的にrefsに追加している。
        // refsの追加がリアクティブに検知できないので、編集時に開いてすぐに選択しても編集ボタンや削除ボタンが有効にならない
        // refsの追加が完了してからListTitleBarを作成するようにすることでその問題を対処する
        private isCreatedListCtrl = false;

        /**
         * @brief	マウント後の処理
         */
        public mounted(): void {
            // リストや設定はここで生成
            if (this.readonly) {
                // 読み取り専用モード：有効な設定だけを表示
                this.createReadonlyList();
            }
            else {
                // 設定モード：全設定を表示
                this.createSettingList();
            }
        }

        /**
         * @brief	表示中の設定を取得する
         */
        public getSetting(): { [key: string]: any } {
            const changedData: { [key: string]: any } = {};

            // 有効の設定だけ送信する
            for (const key in this.listEnabled) {
                if (this.listEnabled[key]) {
                    const bundle: any = this.getRefObj(key);
                    if (undefined == bundle) {
                        // BUNDLE以外
                        changedData[key] = this.settings[key];
                        continue;
                    }

                    // BUNDLE系の子コンポーネントの値を取得する
                    // BUNDLEはbundleコンポーネントは必ず見つかるはず
                    changedData[key] = bundle.getSetting();
                }
            }

            return changedData;
        }

        /**
         * @brief	初期設定に戻す
         */
        public onReset(): void {
            for (const key in this.listEnabled) {
                this.listEnabled[key] = false;
            }
            this.settings = this.converter.CreateMgrConfiguration(this.list, undefined);

            // BUNDLE系の子コンポーネントの値も初期化する
            // キー名が欲しいだけなので、なんでもいいので連想配列のものでループ
            for (const x of this.list) {
                if (null == x.key || undefined == x.key) {
                    // keyがないアクセス権限は想定外
                    continue;
                }

                if ("BUNDLE_ARRAY" == x.type) {
                    // リストの更新が必要
                    this.updateList(x.key, 0);
                }

                const bundle: any = this.getRefObj(x.key);
                if (undefined == bundle) {
                    continue;
                }

                // BUNDLE
                bundle.onReset();
            }
        }

        /**
         * @brief	refs配列から対象を取得する
         * @returns undefined: 見つからなかった
         * @note    オンプレ版に持っていくと[0]でアクセスしないとコンポーネントにアクセスできないので、苦肉の策
         */
        private getRefObj(key: string): any {
            const refObj: any = this.$refs;

            if (undefined == refObj[key]) {
                return undefined;
            }

            if (undefined == refObj[key][0]) {
                // M1はこっち
                return refObj[key]
            }
            else {
                // オンプレはこっち
                return refObj[key][0];
            }
        }

        /**
         * @brief	リストの更新
         */
        private updateList(key: string, retry: number): void {
            const listCtrl: any = this.getRefObj(key + '-list');

            // リストコンポーネントの存在確認
            if (undefined == listCtrl) {
                // 画面表示時はリストコンポーネントが存在していないので、
                // 数回リトライする
                if (1 <= retry) {
                    window.setTimeout(this.updateList, 0, key, retry - 1);
                }
                return;
            }

            if (undefined == this.settings[key]) {
                // 設定がないのは想定外
                return;
            }
            const bundleArraySettings = this.settings[key];

            listCtrl.updateList(bundleArraySettings.length);

            // updateListが呼べたということはリスト作成済みと判断
            if (!this.isCreatedListCtrl) {
                this.isCreatedListCtrl = true;
            }
        }

        /**
         * @brief	読み取り専用のリストを作成する
         */
        private createReadonlyList(): void {
            // 読み取り専用モード：有効な設定だけを表示
            this.listDisp = new Array<schema.AMAPI_ManagedProperty>();
            this.settings = cloneDeep(this.listSetting);
            this.isCreatedListCtrl = false;
            this.lastKey = "";

            this.list.forEach(x => {
                if (null == x.key || undefined == x.key) {
                    // keyがないアクセス権限は想定外
                    return;
                }

                if ("BUNDLE_ARRAY" == x.type) {
                    // リストの更新が必要
                    this.updateList(x.key, 10);
                }

                // 設定にあるやつだけ表示
                if (undefined !== this.listSetting[x.key]) {
                    this.listDisp.push(cloneDeep(x));
                    this.listEnabled[x.key] = true;

                    // 最後のキー名を記録
                    if ("HIDDEN" != x.type) {
                        this.lastKey = x.key;
                    }
                }
            });
        }

        /**
         * @brief	設定モード用のリストを作成する
         */
        private createSettingList(): void {
            // 設定モード：全設定を表示
            this.listDisp = cloneDeep(this.list);
            this.settings = this.converter.CreateMgrConfiguration(this.list, this.listSetting);
            this.isCreatedListCtrl = false;
            this.lastKey = "";

            this.list.forEach(x => {
                if (null == x.key || undefined == x.key) {
                    // keyがないアクセス権限は想定外
                    return;
                }

                if ("BUNDLE_ARRAY" == x.type) {
                    // リストの更新が必要
                    this.updateList(x.key, 10);
                }

                // 設定になければ無効
                if (undefined === this.listSetting[x.key]) {
                    this.listEnabled[x.key] = false;
                }
                else {
                    this.listEnabled[x.key] = true;
                }

                // 最後のキー名を記録
                if ("HIDDEN" != x.type) {
                    this.lastKey = x.key;
                }
            });
        }

        /**
         * @brief	キーから設定を取得します
         * @param[in]   key : 取得したいBUNDLEのキー
         */
        private getListSetting(key: string): { [key: string]: any } {
            if (undefined !== this.listSetting[key]) {
                return this.listSetting[key];
            }

            // 設定が見つからなかったら、空を返す
            const empty: { [key: string]: any } = {};
            return empty;
        }

        /**
         * @brief	リストの選択数を返します
         * @param[in]   key : 取得したいBUNDLE_ARRAYのキー
         */
        private getSelectCount(key: string): number {
            const listCtrl: any = this.getRefObj(key + '-list');

            // マウント前はundefinedの可能性があるのでundefinedチェックが必要
            if (undefined == listCtrl) {
                return 0;
            }
            return listCtrl.getSelectListIndex().length;
        }

        /**
         * @brief	BUNDLE_ARRAYのBUNDLE型を取り出します
         * @param[in]   item : BUNDLE_ARRAY
         */
        private getBundleFromBundleArray(item: schema.AMAPI_ManagedProperty): schema.AMAPI_ManagedProperty | undefined {
            if ("BUNDLE_ARRAY" != item.type) {
                // ここにきているということはBUNDLE_ARRAYだが念のため
                return undefined;
            }

            // BUNDLE_ARRAYのときはnestedPropertiesがBUNDLE型
            if (undefined == item.nestedProperties
                || 0 == item.nestedProperties.length
                || "BUNDLE" != item.nestedProperties[0].type
            ) {
                return undefined;
            }

            return item.nestedProperties[0];
        }

        /**
         * @brief	リストカラム一覧を作成します
         * @param[in]   item : 表示する管理設定
         */
        private createColumns(item: schema.AMAPI_ManagedProperty): Array<SearchColumnData> {
            let columns: Array<SearchColumnData> = new Array<SearchColumnData>();

            // BUNDLE_ARRAYからBUNDLE型を取り出す
            const bundle = this.getBundleFromBundleArray(item);
            if (undefined == bundle || undefined == bundle.nestedProperties) {
                // 取得失敗 or BUNDLE型のnestedPropertiesがundefinedはありえない
                return columns;
            }
            
            // BUNDLE_ARRAYのBUNDLE情報からカラムを作成する
            for (let i = 0; i < bundle.nestedProperties.length; i++) {
                columns = columns.concat(this.createColumn(bundle.nestedProperties[i], i));
            }

            return columns;
        }

        /**
         * @brief	リストカラムを作成します
         * @param[in]   item : 表示する管理設定
         */
        private createColumn(columnInfo: schema.AMAPI_ManagedProperty, id: number): Array<SearchColumnData> {
            let columns = new Array<SearchColumnData>();

            const column = new SearchColumnData();
            column.text = columnInfo.title ?? "";
            column.columnID = id;
            if ('INTEGER' == columnInfo.type) {
                // 数値だけタイプを変更する
                column.dataType = SearchColumnType.number;
                columns.push(column);
            }
            else if ('HIDDEN' == columnInfo.type) {
                // HIDDENは非表示
                return columns;
            }
            else if ('BUNDLE' == columnInfo.type) {
                // BUNDLEは追加のカラムとして扱う
                if (undefined == columnInfo.nestedProperties) {
                    return columns;
                }
                if (this.BUNDLE_ARRAY_TYPE_BUNDLE_BASE_COLUMNID < id) {
                    // 1000以上のidは二階層目以降。ありえない
                    return columns;
                }

                // BUNDLEのベースIDは元のカラムIDに1000掛けた値
                // 0のことを考えて+1しておく
                const bundleColumnID = this.BUNDLE_ARRAY_TYPE_BUNDLE_BASE_COLUMNID * (id + 1);

                for (let j = 0; j < columnInfo.nestedProperties.length; j++) {
                    columns = columns.concat(this.createColumn(columnInfo.nestedProperties[j], bundleColumnID + j));
                }
            }
            else {
                // 上記以外は文字列
                column.dataType = SearchColumnType.string;
                columns.push(column);
            }

            return columns;
        }

        /**
         * @brief	リストを作成します
         * @param[in]   item : 表示する管理設定
         */
        // アロー演算子を用いて、getCellTextに追加のパラメータ(item)を渡せるようにした
        private getCellText = (item: schema.AMAPI_ManagedProperty) => (columnId: number, index: number) => {
            if (undefined == item.key || null == item.key) {
                // キーがないのは想定外
                return "";
            }
            if (undefined == this.settings[item.key]) {
                // 設定がないのは想定外
                return "";
            }
            const bundleArraySettings = this.settings[item.key];

            // BUNDLE_ARRAYからBUNDLE型を取り出す
            const bundle = this.getBundleFromBundleArray(item);
            if (undefined == bundle || undefined == bundle.nestedProperties) {
                // 取得失敗 or BUNDLE型のnestedPropertiesがundefinedはありえない
                return "";
            }

            // 選択された行に設定があるかどうか
            if (bundleArraySettings.length <= index) {
                return "";
            }

            // 表示する情報を取り出す
            // カラムIDはnestedPropertiesのIndex
            // ただしBUNDLEの場合は(nestedPropertiesのIndex + 1) * 1000した値にBundle要素のnestedPropertiesのIndexを足した値
            let target: any = undefined;
            let columnInfo: schema.AMAPI_ManagedProperty;
            if (bundle.nestedProperties.length <= columnId) {
                // BUNDLE
                if (columnId < this.BUNDLE_ARRAY_TYPE_BUNDLE_BASE_COLUMNID) {
                    // 1000未満でbundle.nestedPropertiesを超えることはない
                    return "";
                }

                // 1000で割って切り捨てた値から1引いた値ががnestedPropertiesのIndex
                const bundleColumnID = Math.floor(columnId / this.BUNDLE_ARRAY_TYPE_BUNDLE_BASE_COLUMNID) - 1;

                if (bundle.nestedProperties.length <= bundleColumnID) {
                    return "";
                }

                // Bundle要素のnestedPropertiesからカラム情報を取り出す
                const bundleColumnInfo = bundle.nestedProperties[bundleColumnID];
                const bundleColumnIndex = columnId - (this.BUNDLE_ARRAY_TYPE_BUNDLE_BASE_COLUMNID * (bundleColumnID + 1));
                if (undefined == bundleColumnInfo.nestedProperties || bundleColumnInfo.nestedProperties.length <= bundleColumnIndex) {
                    return "";
                }

                // BUNDLE自体にチェックボックスがついていなかった
                if (undefined == bundleArraySettings[index][bundleColumnInfo.key as string]) {
                    return "設定なし";
                }

                columnInfo = bundleColumnInfo.nestedProperties[bundleColumnIndex];
                target = bundleArraySettings[index][bundleColumnInfo.key as string][columnInfo.key as string];
            }
            else {
                // BUNDLE以外
                columnInfo = bundle.nestedProperties[columnId];
                target = bundleArraySettings[index][columnInfo.key as string];
            }

            // 型で表記変更
            if (undefined == target) {
                return "設定なし";
            }

            switch (columnInfo.type) {
                case 'STRING':
                    {
                        // target = string
                        const data: string = target as string;
                        return data;
                    }

                case 'INTEGER':
                    {
                        // target = number
                        const data: number = target as number;
                        return data.toString();
                    }

                case 'BOOL':
                    {
                        // target = boolean
                        const data: boolean = target as boolean;

                        if (data) {
                            return "有効";
                        }
                        else {
                            return "無効"
                        }
                    }
                
                case 'CHOICE':
                    {
                        // target = string
                        const data: string = target as string;

                        // 選択は設定内容から文言を取り出す
                        if (undefined == columnInfo.entries || null == columnInfo.entries) {
                            return "";
                        }
                        for (let i = 0; i < columnInfo.entries.length; i++) {
                            if ((columnInfo.entries[i].value ?? "") == data) {
                                return columnInfo.entries[i].name ?? "";
                            }
                        }

                        return "";
                    }

                case 'MULTISELECT':
                    {
                        // target = Array<string>
                        const data: Array <string> = target as Array<string>;
                        // 選択は設定内容から文言を取り出す
                        if (undefined == columnInfo.entries || null == columnInfo.entries) {
                            return "";
                        }
                        let str = ""
                        for (let i = 0; i < columnInfo.entries.length; i++) {
                            if (data.includes(columnInfo.entries[i].value ?? "")) {
                                if ("" != str) {
                                    str += ", " + (columnInfo.entries[i].name ?? "");
                                }
                                else {
                                    str = columnInfo.entries[i].name ?? "";
                                }
                            }
                        }

                        return str
                    }

                case 'BUNDLE':
                    // BUNDLE型は列を分けて表示しているので、BUNDLE型でここにくることはありえない
                    return "";

                case 'BUNDLE_ARRAY':
                    // BUNDLE_ARRAYの中のBUNDLE_ARRAYは階層的にありえないはず
                    return "";

                case 'HIDDEN':
                    // HIDDENはカラムで表示されないように防いでいるので、ここに来るのはありえない
                    return "";

                default:
                    return "";
            }
        }

        /**
         * @brief	BUNDLE_ARRAY 追加ボタン
         * @param[in]   item : 表示する管理設定
         */
        private onBtnAdd(item: schema.AMAPI_ManagedProperty): void {
            if (undefined == item.key || null == item.key) {
                // キーがないのは想定外
                return;
            }

            // BUNDLE_ARRAYからBUNDLE型を取り出す
            const bundle = this.getBundleFromBundleArray(item);
            if (undefined == bundle || undefined == bundle.nestedProperties) {
                // 取得失敗 or BUNDLE型のnestedPropertiesがundefinedはありえない
                return;
            }

            // Bundle_Arrayのモダール画面は親が持っている
            this.selectedBunldeArrayKey = item.key;
            this.$emit('showBundleArrayModal', bundle.nestedProperties, [], this.selectedBunldeArrayKey, true);
        }

        /*
         * Bundle_Arrayの追加画面の表示要求（子画面（BUNDLE）からの要求）
         * @param[in] 表示内容：Array<schema.AMAPI_ManagedProperty>
         * @param[in] 設定内容：{ [key: string]: any }
         * @param[in] Bundle_Arrayのキー名：string
         * @param[in] true(追加) false(編集)：boolean
         */
        private showBundleArrayModal(list: Array<schema.AMAPI_ManagedProperty>, listSetting: { [key: string]: any }, bundleArrayKey: string, bAddMode: boolean): void {
            // 親にemitsするだけ
            this.$emit('showBundleArrayModal', list, listSetting, bundleArrayKey, bAddMode);
        }

        /**
         * @brief	BUNDLE_ARRAY 編集ボタン
         * @param[in]   item : 表示する管理設定
         */
        private onBtnUpd(item: schema.AMAPI_ManagedProperty): void {
            if (undefined == item.key || null == item.key) {
                // キーがないのは想定外
                return;
            }
            if (undefined == this.settings[item.key]) {
                // 設定がないのは想定外
                return ;
            }
            const bundleArraySettings = this.settings[item.key];

            // BUNDLE_ARRAYからBUNDLE型を取り出す
            const bundle = this.getBundleFromBundleArray(item);
            if (undefined == bundle || undefined == bundle.nestedProperties) {
                // 取得失敗 or BUNDLE型のnestedPropertiesがundefinedはありえない
                return;
            }

            const listCtrl: any = this.getRefObj(item.key + '-list');
            if (undefined == listCtrl) {
                return;
            }

            // 選択行の取得
            const selectedIndex = listCtrl.getSelectListIndex();

            // 選択行が設定数を超えていないかチェック
            if (0 == selectedIndex.length || bundleArraySettings.length <= selectedIndex[0]) {
                return;
            }

            // Bundle_Arrayのモダール画面は親が持っている
            this.selectedBunldeArrayKey = item.key;
            this.$emit('showBundleArrayModal', bundle.nestedProperties, bundleArraySettings[selectedIndex[0]], this.selectedBunldeArrayKey, false);
        }

        /**
         * @brief	BUNDLE_ARRAY 画面でOKが押下
         * @param[in]   item : 表示する管理設定
         */
        public onBundleArrayModalOK(settings: { [key: string]: any }, key: string, addMode: boolean): void {
            if (key != this.selectedBunldeArrayKey) {
                // 自分が呼び出したところでないので、子供に通知する
                // キー名が欲しいだけなので、なんでもいいので連想配列のものでループ
                for (const parentKey in this.listEnabled) {
                    const bundle: any = this.getRefObj(parentKey);
                    if (undefined == bundle) {
                        continue;
                    }

                    // BUNDLE
                    bundle.onBundleArrayModalOK(settings, key, addMode);
                }
                return;
            }

            // リストコンポーネントの存在確認
            const listCtrl: any = this.getRefObj(this.selectedBunldeArrayKey + '-list');
            if (undefined == listCtrl) {
                return;
            }

            if (undefined == this.settings[this.selectedBunldeArrayKey]) {
                // 設定がないのは想定外
                return;
            }
            const bundleArraySettings = this.settings[this.selectedBunldeArrayKey];

            if (addMode) {
                // 追加するだけ
                bundleArraySettings.push(settings);

                this.updateList(this.selectedBunldeArrayKey, 0);
                return;
            }
            
            // 編集データを更新する
            // 選択行の取得
            const selectedIndex = listCtrl.getSelectListIndex();

            // 選択行が設定数を超えていないかチェック
            if (0 == selectedIndex.length || bundleArraySettings.length <= selectedIndex[0]) {
                return;
            }

            // 更新
            bundleArraySettings[selectedIndex[0]] = settings;
            this.updateList(this.selectedBunldeArrayKey, 0);
        }

        /**
         * @brief	BUNDLE_ARRAY 削除ボタン
         * @param[in]   item : 表示する管理設定
         */
        private onBtnDel(item: schema.AMAPI_ManagedProperty): void {
            if (undefined == item.key || null == item.key) {
                // キーがないのは想定外
                return;
            }

            const listCtrl: any = this.getRefObj(item.key + '-list');
            if (undefined == listCtrl) {
                return;
            }

            const selectedIndex = listCtrl.getSelectListIndex();

            for (let i = selectedIndex.length; 0 < i; i--) {
                this.settings[item.key].splice(selectedIndex[i - 1], 1);
            }

            this.updateList(item.key, 0);
        }
    }
</script>

<style scoped>
    /* 設定タイトル */
    .setting-title-text {
        font-size: 14px;
        word-wrap: break-word; /* はみ出る分は改行 */
    }

    /* 設定 説明 */
    .setting-description-text {
        font-size: 12px;
        line-height: 1.4;
        color: rgba(36,36,36,0.75);
        word-wrap: break-word; /* はみ出る分は改行 */
    }

    /* はみ出したら...にする */
    .over-text {
        overflow: hidden;
        white-space: nowrap;
        padding-right: 26px;
        text-overflow: ellipsis;
    }

    /* 読み取り専用時のテキスト */
    .readonly-text {
        opacity: 0.5;
    }

    /* BUNDLE以外の設定の説明文との間 */
    .setting-no-bundle-margin-top {
        margin-top: 16px;
    }

    /* チェック系の左マージン */
    .setting-check-margin-left {
        margin-left: 24px;  /* 16px + 24pxで40px空ける */
    }

    /* 横一杯に伸ばすコンポーネントの右マージン */
    .full-grow-margin-right {
        margin-right: 16px;
    }
</style>
